import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface GetCENSMEAutoCompleteApiParameter extends ApiParameter {
    query?: string;
}

export interface SMEEmployeeAutoComplete {
    id: string;
    name: string;
    title: string;
    photoUrl: string | null;
    bioSnippet: string;
    expertise: string;
}

export interface CENSMEAutoCompleteModel {
    employeeAutoComplete: SMEEmployeeAutoComplete[];
    productAutoComplete: any[];
    brandAutoComplete: any[];
    branchAutoComplete: any[];
    properties: Record<string, unknown>;
}

const cenSMEAutoCompleteApiUrl = "/api/v2/centroconnect/sme/autocomplete";

export function getCENSMEAutoComplete(parameter?: GetCENSMEAutoCompleteApiParameter) {
    return get<CENSMEAutoCompleteModel>(cenSMEAutoCompleteApiUrl, parameter);
}
